import {
  Button,
  Flex,
  Img,
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useColorModeValue,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { BsFillCameraFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useGetState } from "../../../context/useGetState";
import axios from "axios";
function CreateLiveStream() {
  const { state } = useGetState();
  const { userInfo } = state;
  console.log('usepic',userInfo?.picture)
  const imgRef = useRef(null);
  const [img, setImg] = useState(null);
  const [url, setUrl] = useState(null);
  const initValues = {
    name: "",
    trial_period: "",
    price: "",
    duration: "monthly",
    description: "",
    category: "",
  };
  const [formValues, setFormValues] = useState(initValues);
  const [previewImg, setPreviewImg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectPlan, setSelectPlan] = useState("free");
  const containerBgColor = useColorModeValue("#F9FAFC", "#020b19");
  const inputBgColor = useColorModeValue("#fff", "#081b2e");
  const navigate = useNavigate();
  const account_type = userInfo?.account_type;

  // convert file to a base64 url
  const readURL = (file) => {
    return new Promise((res, rej) => {
      const reader = new FileReader();
      reader.onload = (e) => res(e.target.result);
      reader.onerror = (e) => rej(e);
      reader.readAsDataURL(file);
    });
  };

  const inputStyles = {
    borderRadius: "10px",
    boxShadow: "3px 8px 13px 0px #8080800f",
    bg: inputBgColor,
    w: "100%",
    fontSize: ".9em",
    color: "#697C94",
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmitForm = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("photo", img);
    formData.append("name", formValues?.name);
    formData.append("description", formValues?.description);
    formData.append("category", formValues?.category);
    formValues?.trial_period &&
      formData.append("trial_period", formValues?.trial_period);
    formData.append("price", formValues?.price);
    formData.append("duration", formValues?.duration);
    formData.append("type", selectPlan);
  };
  console.log('username info',userInfo)

  return (
    <Stack
      direction={"row"}
      flexDirection={["column", "row", "row", "row"]}
      spacing={["unset", "50px", "50px", "50px"]}
      pr={["unset", "60px"]}
    >
      <Stack flex="1" alignItems={["center", "unset", "unset", "unset"]}>
        {img ? (
          <Stack
            position={"relative"}
            maxW="200px"
            maxH="150px"
            objectFit={"cover"}
            w="200px"
            h="150px"
            cursor={"pointer"}
            onClick={() => imgRef.current.click()}
          >
            <Img
              w="200px"
              h="150px"
              objectFit={"cover"}
              src={previewImg}
              alt="profile pic"
            />
            <BsFillCameraFill
              fontSize={"1.5em"}
              style={{
                position: "absolute",
                transform: "translate(90px, 50px)",
              }}
            />
          </Stack>
        ) : (
          <Stack
            w="200px"
            h="150px"
            borderRadius={"10px"}
            bg="#707070"
            py="20px"
            justifyContent={"center"}
            alignItems="center"
            color="#fff"
            cursor={"pointer"}
            onClick={() => imgRef.current.click()}
          >
            <BsFillCameraFill fontSize={"1.5em"} />
            <Text fontSize={".8em"} textAlign="center">
              Click to change
              <br /> Image
            </Text>
          </Stack>
        )}
      </Stack>
      <Input
        type="file"
        ref={imgRef}
        accept="image/jpg, image/jpeg, image/png"
        display={"none"}
        onChange={async (e) => {
          setImg(e.target.files?.[0]);

          setPreviewImg(await readURL(e.target.files?.[0]));
          
       
          

        }}
      />
      <Stack
        flex="4"
        bg={containerBgColor}
        borderRadius={"15px"}
        p={["unset", "20px", "20px", "20px"]}
        alignItems={"center"}
        mt={["20px !important", "unset", "unset", "unset"]}
      >
        <Stack maxW="400px" w="350px" spacing={"25px"}>
          <Input
            placeholder="Title"
            type="text"
            name="name"
            value={formValues?.name}
            onChange={handleChange}
            {...inputStyles}
          />
          <Textarea
            rows={"8"}
            resize="none"
            placeholder="Describe Your Livestream..."
            name="description"
            value={formValues?.description}
            onChange={handleChange}
            {...inputStyles}
          />
          <style>{`
          .chakra-select__wrapper{
            background: ${inputBgColor};
            box-shadow: 3px 8px 13px 0px #8080800f;
            border-radius: 10px;
            padding: 10px;
          }
          `}</style>

          <Stack direction={"row"} alignItems="center">
            <Text
              cursor={"pointer"}
              {...inputStyles}
              p="15px"
              {...(selectPlan === "free" ? inputStyles : {})}
              fontSize="initial"
              color={selectPlan === "free" && "#fff"}
              bg={selectPlan === "free" && "grey"}
              onClick={() => setSelectPlan("free")}
            >
              Free
            </Text>
            <Text
              {...inputStyles}
              p="15px"
              cursor="pointer"
              {...(selectPlan === "free" ? inputStyles : {})}
              fontSize="initial"
              color={selectPlan === "paid" && "#fff"}
              bg={selectPlan === "paid" && "grey"}
              onClick={() => setSelectPlan("paid")}
              fontWeight="medium"
            >
              Paid
            </Text>
          </Stack>
          {selectPlan === "paid" && (
            <Input
              type={"text"}
              placeholder="Amount"
              disabled={selectPlan === "free"}
              {...inputStyles}
              name="price"
              value={formValues?.price}
              onChange={handleChange}
            />
          )}

          <Flex flexDirection={"row"} alignItems="center" gap="20px">
            <Button
              color="#fff"
              h="50px"
              w="250px"
              bg="#E01D1F"
              _hover={{ background: "#E01D1F" }}
              alignSelf={"center"}
              borderRadius="15px"
              onClick={async () =>
                // navigate("/view-live-stream", { state: { room: formValues?.name } })
                {
                  const data = new FormData();
          data.append("file", img);
          data.append(
            "upload_preset",
            "t7qi5z8g"
          );
          data.append("cloud_name", "datl9mo3g");
          data.append("folder", "flashcard");
      
          try {
            const response = await fetch(
              `https://api.cloudinary.com/v1_1/datl9mo3g/image/upload`,
              {
                method: "POST",
                body: data,
              }
            );
            const res = await response.json();
            console.log('image -->',res.secure_url);
            setUrl(res.secure_url);
            console.log('image2 -->',url);
            navigate("/view-live-stream", { state: { room: formValues?.name ,url:res?.secure_url?res.secure_url:null,description:formValues?.description} })
            // setLoading(false);
          } catch (error) {
            // setLoading(false);
          }
                }
              }
            >
              Go Live Now
            </Button>
            <Button
              color="#fff"
              h="50px"
              w="250px"
              bg="#50BB69"
              _hover={{ background: "#50BB69" }}
              alignSelf={"center"}
              borderRadius="15px"
            >
              Schedule Live
            </Button>
          </Flex>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default CreateLiveStream;
